import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { Button, Col, Form, FormGroup, Input, Label, PopoverBody, Row, UncontrolledPopover, Tooltip, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import instance from "../../../axiosInstance";
import { useUpdateFormContext } from "../../../context/administration/updateForm";
import { useHireContext } from "../../../context/administration/updateForm/hire";
import useError from "../../../hooks/useError";
import { toDateObj, toYYYYMMDD } from "../../../utils/forms";
import CustomDate from "../../UI/forms/CustomDate";
import Notes from "./Notes";
import LoadingButton from "../../UI/LoadingButton";
import ParamsLink from "../../UI/links/ParamsLink";
import { validatePhoneNumber } from "../../../utils/validations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faTimesCircle, faClock, faCheckCircle, faInfo, faInfoCircle, faUser, faCar, faExclamationTriangle, faUserShield, faLock } from "@fortawesome/free-solid-svg-icons";
import { loadLeadSourceOptionsWithDetails } from "./PersonalInjury";
import ContactLink from "../../UI/links/ContactLink";
import EmailLink from "../../UI/links/EmailLink";
import RequiredLabel from "../../UI/forms/RequiredLabel";
import moment from "moment";
// import { loadLeadSourceOptions } from "./PersonalInjury";

const yesOrNoOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

let loadedHireApprovedOption = [];
export const loadHireApprovedOption = async (search) => {
  try {
    if (search && loadedHireApprovedOption.length) {
      const filteredOptions = loadedHireApprovedOption.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
      return {
        options: filteredOptions,
        hasMore: false,
      };
    }

    const res = await instance.get("/lookups/hireApproved");
    const { data } = res.data;
    const options = data.map((status) => ({
      value: status,
      label: status,
    }));

    loadedHireApprovedOption = options;

    return {
      options,
      hasMore: false,
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

let loadedHireCategories = [];
export const loadHireCategories = async (search) => {
  try {
    if (search && loadedHireCategories.length) {
      const filteredOptions = loadedHireCategories.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
      return {
        options: filteredOptions,
        hasMore: false,
      };
    }

    const res = await instance.get("/lookups/hireCategory");
    const { data } = res.data;
    const options = data.map((category) => ({
      value: category,
      label: category,
    }));

    loadedHireCategories = options;

    return {
      options,
      hasMore: false,
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

let loadedHireStatus = [];
export const loadHireStatus = async (search) => {
  try {
    if (search && loadedHireStatus.length) {
      const filteredOptions = loadedHireStatus.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
      return {
        options: filteredOptions,
        hasMore: false,
      };
    }

    const res = await instance.get("/lookups/hireStatus");
    const { data } = res.data;
    const options = data.map((category) => ({
      value: category,
      label: category,
    }));

    loadedHireStatus = options;

    return {
      options,
      hasMore: false,
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

export const loadLeadSourceOptions = async (search, loadedOptions, { page, userTypes = [] }) => {
  try {
    const res = await instance.get("/lookups/leadSources", {
      params: { search, page, limit: 10, userTypes: userTypes },
    });

    const { data } = res.data;
    const options = data.data.map((role) => ({
      value: role.user_id,
      label: role.full_name,
    }));

    return {
      options,
      hasMore: page < data.total_pages,
      additional: {
        page: page + 1,
      },
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

export const loadHireSuppliers = async (search, loadedOptions, { page }) => {
  try {
    const res = await instance.get("/lookups/hireSuppliers", {
      params: { search, page, limit: 10 },
    });

    const { data } = res.data;
    const options = data.data.map((role) => ({
      value: role.user_id,
      label: role.full_name,
    }));

    return {
      options,
      hasMore: page < data.total_pages,
      additional: {
        page: page + 1,
      },
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

export const loadHireSuppliersForLeadSource = async (search, loadedOptions, { page, hireLeadSource }) => {
  try {
    const res = await instance.get("/lookups/hireSuppliersForLeadSource", {
      params: { search, page, limit: 10, lead_source_id: hireLeadSource?.value || hireLeadSource?.lead_source_id },
    });

    const { data } = res.data;
    const options = data.data.map((role) => ({
      value: role.user_id,
      label: role.full_name
    }));

    return {
      options,
      hasMore: page < data.total_pages,
      additional: {
        page: page + 1,
      },
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

let loadedRejectReason = [];
export const loadRejectReason = async (search) => {
  try {
    if (search && loadedRejectReason.length) {
      const filteredOptions = loadedRejectReason.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
      return {
        options: filteredOptions,
        hasMore: false,
      };
    }

    const res = await instance.get("/lookups/hireRejectReason");
    const { data } = res.data;
    const options = data.map((status) => ({
      value: status,
      label: status,
    }));

    loadedRejectReason = options;

    return {
      options,
      hasMore: false,
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false,
    };
  }
};

const reviewChip = { gap: 4, padding: '1px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', lineHeight: '18px' };

const Hire = ({ getFormData }) => {
  const { formId } = useParams();

  const {
    userType,
    setUserType,
    hireApproved,
    setHireApproved,
    hireCategory,
    setHireCategory,
    hireBookingDate,
    setHireBookingDate,
    hireLeadSource,
    setHireLeadSource,
    hireCommenceDate,
    setHireCommenceDate,
    hireRefNo,
    setHireRefNo,
    hireSupplier,
    setHireSupplier,
    hireCompleteDate,
    setHireCompleteDate,
    outlay,
    setOutlay,
    sourceHirePaidDate,
    setSourceHirePaidDate,
    sourceHirePaidAmount,
    setSourceHirePaidAmount,
    naslHirePaidDateFE,
    setNaslHirePaidDateFE,
    naslHirePaidAmountFe,
    setNaslHirePaidAmountFe,
    naslHirePaidDateBE,
    setNaslHirePaidDateBE,
    naslHirePaidAmountBe,
    setNaslHirePaidAmountBe,
    hireAccessoriesPaymentDate,
    setHireAccessoriesPaymentDate,
    accessoriesPaymentAmount,
    setAccessoriesPaymentAmount,
    paServicingDate,
    setPaServicingDate,
    paServicingAmount,
    setPaServicingAmount,
    hireStatus,
    setHireStatus,
    rejectReason,
    setRejectReason,
    rejection_date,
    setRejectionDate,
    hireChaseDate,
    setHireChaseDate,
    hireTransferDate,
    setHireTranserDate,
    naslAccessoriesPaymentDate,
    setNaslAccessoriesPaymentDate,
    naslAccessoriesPaymentAmount,
    setNaslAccessoriesPaymentAmount,
    priority,
    setPriority,

    sourceHirePaidStatus,
    setSourceHirePaidStatus,
    naslHirePaidStatusFE,
    setNaslHirePaidStatusFE,
    naslHirePaidStatusBE,
    setNaslHirePaidStatusBE,
    accessoryPamentStatus,
    setAccessoryPamentStatus,
    servicingPaymentStatus,
    setservicingPaymentStatus,
    naslAccessoryPamentStatus,
    setNaslAccessoryPamentStatus,

    // -----note's values-------
    isAddNotActive,
    setIsAddNotActive,
    isPinNoteActive,
    setIsPinNoteActive,
    isAddAsReminderActive,
    setIsAddAsReminderActive,
    isSendEmailActive,
    setIsSendEmailActive,
    isSendSMSActive,
    setIsSendSMSActive,
    isTaskActive,
    setIsTaskActive,
    taskUsers,
    setTaskUsers,

    noteDescription,
    setNoteDescription,
    addNoteTo,
    setAddNoteTo,
    isAddNoteOnCallActive,
    setIsAddNoteOnCallActive,
    addAsReminderDate,
    setAddAsReminderDate,
    reminderUsers,
    setReminderUsers,
    sendEmailTo,
    setSendEmailTo,
    sendSMSTo,
    setSendSMSTo,
    sendSMSMobile,
    setSendSMSMobile,
  } = useHireContext();

  const [validationErrors, setValidationErrors] = useState({
    mobileNumber: "",
    clientNumber: "",
  });

  const clearNoteFields = () => {
    setIsAddNotActive(false);
    setIsPinNoteActive(false);
    setIsAddAsReminderActive(false);
    setIsSendEmailActive(false);
    setIsSendSMSActive(false);
    setIsTaskActive(false);
    setTaskUsers([]);
    setNoteDescription("");
    setAddNoteTo("");
    setIsAddNoteOnCallActive(false);
    setAddAsReminderDate(null);
    setReminderUsers([]);
    setSendEmailTo("");
    setSendSMSTo("");
    setSendSMSMobile({
      clientNumber: "",
      mobileNumber: "",
    });
  };

  const { handleError } = useError();
  const [isUpdating, setIsUpdating] = useState(false);
  const [isKindertonSupplier, setIsKindertonSupplier] = useState(false);
  const [isEnterpriseSupplier, setIsEnterpriseSupplier] = useState(false);
  const [alreadyPosted, setAlreadyPosted] = useState(false);
  const [reviewInfo, setReviewInfo] = useState({}); // { review_status, review_reject_reason, reviewed_by, reviewed_at }
  const [submitReviewOpen, setSubmitReviewOpen] = useState(false);
  const [reasonModalOpen, setReasonModalOpen] = useState(false);
  const [isSubmittingReview, setIsSubmittingReview] = useState(false);
  const [postTipOpen, setPostTipOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [enterpriseConfirmOpen, setEnterpriseConfirmOpen] = useState(false);
  // supplier id as stored in the database; differs from the selection until Update is clicked
  const [savedSupplierId, setSavedSupplierId] = useState(null);
  const supplierUnsaved = String(hireSupplier?.value ?? '') !== String(savedSupplierId ?? '');
  const needsReview = isKindertonSupplier || isEnterpriseSupplier;
  // supplier is frozen only while a review is pending; accept / reject / post unlock it
  const reviewLocked = needsReview && reviewInfo.review_status === 'submit_for_review';
  const reviewSupplierLabel = isKindertonSupplier ? 'Kinderton' : 'Enterprise';
  const [selectedReferrerCode, setSelectedReferrerCode] = useState('');
  const [postErrors, setPostErrors] = useState(null); // { title, errors, traceId, correlationId }
  const [claimTypeSelection, setClaimTypeSelection] = useState(''); // 'COI' or 'TPI'
  const [workstreamSelection, setWorkstreamSelection] = useState('23677'); // '23677' Default | '25793' Laird's
  const [isPosting, setIsPosting] = useState(false);


  // popover 
  const [popoverOpen, setPopoverOpen] = useState(false);
  const popoverRef = useRef(null);
  const popoverContentRef = useRef(null);

  const togglePopover = () => setPopoverOpen(!popoverOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        popoverContentRef.current &&
        !popoverContentRef.current.contains(event.target)
      ) {
        setPopoverOpen(false);
      }
    };

    if (popoverOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popoverOpen]);
  // ---------------- 


  const { formData, getNotes } = useUpdateFormContext();

  const setFields = () => {
    if (!formData || !formData.hire) return;
    const { hire } = formData;
    const { user } = formData;

    setUserType(user.user_type)
    setSendSMSMobile((prevState) => ({ ...prevState, clientNumber: (!formData?.mobile_no?.startsWith('+') ? ('+' + formData?.mobile_no) : formData?.mobile_no) }))

    setHireApproved({ value: hire.approved_status, label: hire.approved_status });
    setHireCategory({ value: hire.category, label: hire.category });
    console.log(hire, "hire");
    setHireLeadSource({
      value: hire.lead_source_id, label: hire.lead_source_name,
      introducer: hire?.introducer_name,
      contact: hire?.lead_source_contact,
      mobile: hire?.lead_source_mobile,
      email: hire?.lead_source_email,
      hire_preference: hire?.lead_source_hire_preference,
      instructions: hire?.lead_source_instructions,
    });
    setHireBookingDate(toDateObj(hire.on_hire_date));
    setHireCommenceDate(toDateObj(hire.commence_date));
    setHireRefNo(hire.ref_no);
    setHireSupplier({ value: hire.supplier_id, label: hire.supplier_name });
    setSavedSupplierId(hire.supplier_id ?? null);
    setHireCompleteDate(toDateObj(hire.complete_date));
    setOutlay({ value: hire.outlay_status, label: hire.outlay_status });
    setSourceHirePaidDate(toDateObj(hire.source_paid_date));
    setSourceHirePaidAmount(hire.source_paid_amount);
    setNaslHirePaidDateFE(toDateObj(hire.fe_paid_date));
    setNaslHirePaidAmountFe(hire.fe_paid_amount);
    setNaslHirePaidDateBE(toDateObj(hire.be_paid_date));
    setNaslHirePaidAmountBe(hire.be_paid_amount);
    setHireAccessoriesPaymentDate(toDateObj(hire.accessories_paid_date));
    setAccessoriesPaymentAmount(hire.accessories_paid_amount);
    setPaServicingDate(toDateObj(hire.pa_paid_date));
    setPaServicingAmount(hire.pa_paid_amount);
    setHireStatus({ value: hire.hire_status, label: hire.hire_status });
    setRejectReason({ value: hire.rejection_reason, label: hire.rejection_reason });
    setRejectionDate(toDateObj(hire.rejection_date));
    setHireChaseDate(toDateObj(hire.chase_date));
    setHireTranserDate(toDateObj(hire.transfer_date));
    setNaslAccessoriesPaymentDate(toDateObj(hire.nasl_accessories_paid_date));
    setNaslAccessoriesPaymentAmount(hire.nasl_accessories_paid_amount);
    setPriority(hire.hire_priority);

    // Status
    setSourceHirePaidStatus(hire.source_paid_status === "Yes");
    setNaslHirePaidStatusFE(hire.fe_paid_status === "Yes");
    setNaslHirePaidStatusBE(hire.be_paid_status === "Yes");
    setAccessoryPamentStatus(hire.accessories_paid_status === "Yes");
    setservicingPaymentStatus(hire.pa_paid_status === "Yes");
    setNaslAccessoryPamentStatus(hire.nasl_accessories_paid_status === "Yes");
  };

  useEffect(() => {
    setFields();
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    if (hireLeadSource) {
      // Reset the supplier when lead source changes
      // setHireSupplier(null);
    }
  }, [hireLeadSource]);

  const updateHandler = async () => {
    let isInvalid = false;

    // if (!validatePhoneNumber(sendSMSMobile.clientNumber)) {
    //   setValidationErrors((prevErrors) => ({ ...prevErrors, clientNumber: "Invalid client number" }));
    //   isInvalid = true;
    // } else {
    //   setValidationErrors((prevErrors) => ({ ...prevErrors, clientNumber: "" }));
    // }

    if (!validatePhoneNumber(sendSMSMobile.mobileNumber)) {
      setValidationErrors((prevErrors) => ({ ...prevErrors, mobileNumber: "Invalid mobile number" }));
      isInvalid = true;
    } else {
      setValidationErrors((prevErrors) => ({ ...prevErrors, mobileNumber: "" }));
    }
    if (!hireStatus?.value) {
      setValidationErrors((prevErrors) => ({ ...prevErrors, hireStatus: "Hire Status is required" }));
      isInvalid = true;
    } else {
      setValidationErrors((prevErrors) => ({ ...prevErrors, hireStatus: "" }));
    }

    if (isInvalid) return;

    if (isTaskActive) {
      if (!String(noteDescription || "").trim()) {
        toastr.error("Error", "Task requires a note description.");
        return;
      }
      if (!Array.isArray(taskUsers) || taskUsers.length === 0) {
        toastr.error("Error", "Task requires at least one assignee.");
        return;
      }
    }

    if (isPinNoteActive) {      
      if (!String(noteDescription || "").trim()) {
        toastr.error("Error", "Pin note requires a note description.");
        return;
      }
    }

    try {
      setIsUpdating(true);
      const payload = {
        approved_status: hireApproved?.value || "",
        category: hireCategory?.value || "",
        commence_date: toYYYYMMDD(hireCommenceDate),
        ref_no: hireRefNo,
        supplier_id: hireSupplier?.value || "",
        outlay_status: outlay?.value || "",
        source_paid_date: toYYYYMMDD(sourceHirePaidDate),
        source_paid_status: sourceHirePaidStatus ? "Yes" : "No",
        source_paid_amount: sourceHirePaidAmount,
        fe_paid_date: toYYYYMMDD(naslHirePaidDateFE),
        fe_paid_status: naslHirePaidStatusFE ? "Yes" : "No",
        fe_paid_amount: naslHirePaidAmountFe,
        be_paid_date: toYYYYMMDD(naslHirePaidDateBE),
        be_paid_status: naslHirePaidStatusBE ? "Yes" : "No",
        be_paid_amount: naslHirePaidAmountBe,
        complete_date: toYYYYMMDD(hireCompleteDate),
        accessories_paid_date: toYYYYMMDD(hireAccessoriesPaymentDate),
        accessories_paid_status: accessoryPamentStatus ? "Yes" : "No",
        accessories_paid_amount: accessoriesPaymentAmount,
        pa_paid_date: toYYYYMMDD(paServicingDate),
        pa_paid_status: servicingPaymentStatus ? "Yes" : "No",
        pa_paid_amount: accessoriesPaymentAmount,
        hire_status: hireStatus?.value || "",
        chase_date: toYYYYMMDD(hireChaseDate),
        transfer_date: toYYYYMMDD(hireTransferDate),
        nasl_accessories_paid_date: toYYYYMMDD(naslAccessoriesPaymentDate),
        nasl_accessories_paid_status: naslAccessoryPamentStatus ? "Yes" : "No",
        nasl_accessories_paid_amount: naslAccessoriesPaymentAmount,
        hire_priority: priority || "",
        on_hire_date: toYYYYMMDD(hireBookingDate),
        rejection_reason: rejectReason?.value || "",
        note: {
          note_type: "Hire",
          description: noteDescription,
          display_to_deo: addNoteTo.displayToDEO ? 1 : 0,
          display_to_client: addNoteTo.displayToClient ? 1 : 0,
          display_to_cho: addNoteTo.displayToCHO ? 1 : 0,
          is_add_note_on_call: isAddNoteOnCallActive ? 1 : 0,
          reminder_date: addAsReminderDate ? moment(addAsReminderDate).format('YYYY-MM-DD HH:mm:ss') : null,
          reminder_user_ids: Array.isArray(reminderUsers) ? reminderUsers.map((u) => u.value) : [],
          task_user_ids: isTaskActive && Array.isArray(taskUsers) ? taskUsers.map((u) => u.value) : [],
          send_email_source: sendEmailTo.source ? 1 : 0,
          send_email_client: sendEmailTo.client ? 1 : 0,
          send_sms_to: isSendSMSActive ? sendSMSTo : null,
          send_sms_mobile: sendSMSTo === "client" ? sendSMSMobile.clientNumber : sendSMSMobile.mobileNumber,
          pin_note:
            isPinNoteActive && String(noteDescription || "").trim() ? 1 : 0,
        },
      };

      if (hireLeadSource) payload.lead_source_id = +hireLeadSource.value;

      await instance.put(`/case/updateHire/${formId}`, payload);
      toastr.success("Success", "Hire updated successfully");
      clearNoteFields();
      getNotes();
      getFormData();
      setTimeout(() => {
        // window.location.reload();
      }, 800);
    } catch (error) {
      handleError(error);
    } finally {
      setIsUpdating(false);
    }
  };
  const [isLoading, setIsLoading] = useState(false);


  const sendXML = async () => {
    try {
      await instance.get(`/hire/emailXML/${formId}`, {
        params: {
          supplier_id: hireSupplier?.value
        }
      });
      toastr.success("Success", "Sent successfully");
    } catch (error) {
      handleError(error);
    }
  }

  const checkKindertonSupplier = async (supplierId) => {
    try {
      if (!supplierId) {
        setIsKindertonSupplier(false);
        setIsEnterpriseSupplier(false);
        setAlreadyPosted(false);
        setReviewInfo({});
        return;
      }
      const res = await instance.get('/setting/is_hire_supplier', { params: { supplier_id: supplierId, case_id: formId } });
      const responseData = res.data?.data || res.data;
      console.log('Full API response:', res.data); // Debug log
      console.log('Supplier check response data:', responseData); // Debug log
      console.log('Supplier ID being checked:', supplierId); // Debug log
      setIsKindertonSupplier(!!responseData?.is_kinderton);
      setIsEnterpriseSupplier(!!responseData?.is_enterprise);
      setAlreadyPosted(!!responseData?.already_posted);
      setReviewInfo(responseData || {});
      console.log('State updated - isKinderton:', !!responseData?.is_kinderton, 'isEnterprise:', !!responseData?.is_enterprise, 'alreadyPosted:', !!responseData?.already_posted); // Debug log
    } catch (error) {
      // silent fail, just hide button
      console.error('Error checking supplier:', error); // Debug log
      setIsKindertonSupplier(false);
      setIsEnterpriseSupplier(false);
      setAlreadyPosted(false);
      setReviewInfo({});
    }
  };

  const submitForReview = async () => {
    try {
      setIsSubmittingReview(true);
      await instance.post(`/case/submitHireForReview/${formId}`);
      toastr.success("Success", "Case submitted for review");
      setSubmitReviewOpen(false);
      await checkKindertonSupplier(hireSupplier?.value);
      getNotes();
    } catch (error) {
      handleError(error);
    } finally {
      setIsSubmittingReview(false);
    }
  };

  // Save supplier assignment breach when supplier changes
  useEffect(() => {
    // Always check already-posted state by case_id before any match check
    checkKindertonSupplier(hireSupplier?.value);
  }, [hireSupplier?.value, formId]);

  const postToKinderton = async () => {
    try {
      setIsPosting(true);
      const res = await instance.post(`/case/kindertonApi/${formId}`, {
        claimTypeSelection: claimTypeSelection,
        referringSourceId: workstreamSelection
      });
      const payload = res?.data?.data || {};
      if (payload?.kinderton_error) {
        const title = payload?.title || 'Validation failed';
        const errorsObj = payload?.errors || {};
        setPostErrors({ title, errors: errorsObj, traceId: payload?.traceId, correlationId: payload?.correlationId });
        const flatErrors = Object.entries(errorsObj)
          .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
          .join('\n');
        toastr.error(title, flatErrors || 'Please review the form data');
        return;
      }
      // Handle unexpected success format
      if (payload?.warning) {
        toastr.warning("Warning", payload.warning);
      }
      const apiMsg = payload?.message || (payload?.claim_reference ? `Posted to Kinderton successfully with claim reference ${payload?.claim_reference}` : 'Unable to post to Kinderton, claim reference not found');
      toastr.success(payload?.claim_reference ? "Success" : "Warning", apiMsg);
      if (payload?.claim_reference) {
        setConfirmOpen(false);
        setAlreadyPosted(true);
      } else {
        setConfirmOpen(false);
      }

      setPostErrors(null);
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || 'Failed to post to Kinderton';
      const detail = error?.response?.data?.error || error?.response?.data?.data || '';
      toastr.error('Error', msg + (detail ? `: ${typeof detail === 'string' ? detail : JSON.stringify(detail)}` : ''));
    } finally {
      setIsPosting(false);
    }
  };

  const validateEnterpriseFields = () => {
    const categorizedErrors = {
      clientDetails: [],
      clientVehicle: [],
      accidentDetails: [],
      defendantDetails: []
    };
    
    if (!formData) {
      categorizedErrors.clientDetails.push("Form data is not available");
      return categorizedErrors;
    }

    // Client Details
    if (!formData.title?.trim()) categorizedErrors.clientDetails.push("Title");
    if (!formData.first_name?.trim()) categorizedErrors.clientDetails.push("First Name");
    if (!formData.last_name?.trim()) categorizedErrors.clientDetails.push("Last Name");
    if (!formData.mobile_no?.trim()) categorizedErrors.clientDetails.push("Mobile Phone");
    if (!formData.post_code?.trim()) categorizedErrors.clientDetails.push("Post Code");
    if (!formData.address?.trim()) categorizedErrors.clientDetails.push("Address");
    if (!formData.email_address?.trim()) categorizedErrors.clientDetails.push("Email Address");
    if (!formData.date_of_birth?.trim()) categorizedErrors.clientDetails.push("Date of Birth");
    if (!formData.insurer?.trim()) categorizedErrors.clientDetails.push("Insurer");
    if (!formData.policy_number?.trim()) categorizedErrors.clientDetails.push("Policy Number");

    // Client Vehicle
    if (!formData.vehicle_registration_no?.trim()) categorizedErrors.clientVehicle.push("Registration Number");
    if (!formData.vehicle_make?.trim()) categorizedErrors.clientVehicle.push("Make");
    if (!formData.vehicle_model?.trim()) categorizedErrors.clientVehicle.push("Model");
    if (!formData.registered_keeper?.trim()) categorizedErrors.clientVehicle.push("Registered Keeper");
    if (!formData.damage_to_vehicle?.trim()) categorizedErrors.clientVehicle.push("Damage to Vehicle");
    if (!formData.vehicle_location?.trim()) categorizedErrors.clientVehicle.push("Vehicle Location");
    if (!formData.vehicle_colour?.trim()) categorizedErrors.clientVehicle.push("Colour");
    if (!formData.insurance_type?.trim()) categorizedErrors.clientVehicle.push("Insurance Type");
    
    // Check at least one damage field is filled
    const hasDamage = (
      (formData.front_damage?.trim()) ||
      (formData.rear_damage?.trim()) ||
      (formData.near_side_damage?.trim()) ||
      (formData.off_side_damage?.trim()) ||
      (formData.roof_damage?.trim()) ||
      (formData.chassis_damage?.trim()) ||
      (formData.other_damage?.trim())
    );
    if (!hasDamage) categorizedErrors.clientVehicle.push("At least one damage field");

    // Accident/Injury Details
    if (!formData.ib_claim?.accident_type?.trim()) categorizedErrors.accidentDetails.push("Accident Type");
    if (!formData.ib_claim?.accident_date?.trim()) categorizedErrors.accidentDetails.push("Accident Date");
    if (!formData.ib_claim?.accident_time?.trim()) categorizedErrors.accidentDetails.push("Accident Time");
    if (!formData.ib_claim?.accident_location?.trim()) categorizedErrors.accidentDetails.push("Accident Location");
    if (!formData.ib_claim?.accident_description?.trim()) categorizedErrors.accidentDetails.push("Description of Accident");

    // Defendant Details
    if (!formData.defendant_title?.trim()) categorizedErrors.defendantDetails.push("Title");
    if (!formData.defendant_first_name?.trim()) categorizedErrors.defendantDetails.push("First Name");
    if (!formData.defendant_surname?.trim()) categorizedErrors.defendantDetails.push("Surname");
    if (!formData.defendant_vehicle_registration_no?.trim()) categorizedErrors.defendantDetails.push("Registration Number");
    if (!formData.defendant_vehicle_make_model?.trim()) categorizedErrors.defendantDetails.push("Vehicle Make/Model");

    return categorizedErrors;
  };

  const postToEnterprise = async (referrerCode) => {
    try {
      // Validate mandatory fields before making API call
      // const validationErrors = validateEnterpriseFields();
      // const hasErrors = Object.values(validationErrors).some(errors => errors.length > 0);
      // if (hasErrors) {
      //   const errorTitle = "Missing Required Fields";
      //   toastr.error(errorTitle, "Please complete all required fields before proceeding.");
      //   setPostErrors({ title: errorTitle, errors: validationErrors, categorized: true });
      //   return;
      // }

      setIsPosting(true);
      // Get demo payload
      const payloadRes = await instance.get(`/case/enterpriseCaseScript/${formId}`);
      const demoPayload = payloadRes?.data?.data || {};

      // Show demo payload in console/log (as requested - simple demo payload)
      console.log('Enterprise API Demo Payload:', JSON.stringify(demoPayload, null, 2));

      // Post to Enterprise API with referrer code
      const res = await instance.post(`/case/enterpriseApi/${formId}`, {
        referrerCode: referrerCode
      });
      const payload = res?.data?.data || {};
      if (payload?.kinderton_error) {
        const title = payload?.title || 'Validation failed';
        const errorsObj = payload?.errors || {};
        setPostErrors({ title, errors: errorsObj, traceId: payload?.traceId, correlationId: payload?.correlationId });
        const flatErrors = Object.entries(errorsObj)
          .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
          .join('\n');
        toastr.error(title, flatErrors || 'Please review the form data');
        return;
      }
      // Handle unexpected success format
      if (payload?.warning) {
        toastr.warning("Warning", payload.warning);
      }
      const apiMsg = payload?.message || (payload?.ehiUId || payload?.transactionID || payload?.claim_reference ? `Posted to Enterprise successfully with ehiUId ${payload?.ehiUId || payload?.transactionID || payload?.claim_reference}` : 'Unable to post to Enterprise, ehiUId not found');
      toastr.success(payload?.ehiUId || payload?.transactionID || payload?.claim_reference ? "Success" : "Warning", apiMsg);
      if (payload?.ehiUId || payload?.transactionID || payload?.claim_reference) {
        setEnterpriseConfirmOpen(false);
        setSelectedReferrerCode('');
        setAlreadyPosted(true);
      } else {
        setEnterpriseConfirmOpen(false);
        setSelectedReferrerCode('');
      }

      setPostErrors(null);
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || 'Failed to post to Enterprise';
      const detail = error?.response?.data?.error || error?.response?.data?.data || '';
      
      // Handle backend validation errors
      if (error?.response?.data?.error === 'Missing Required Fields' && error?.response?.data?.log_error) {
        const backendErrors = error?.response?.data?.log_error;
        const errorTitle = "Missing Required Fields";
        toastr.error(errorTitle, "Please complete all required fields before proceeding.");
        setPostErrors({ title: errorTitle, errors: backendErrors, categorized: true });
      } else {
        toastr.error('Error', msg + (detail ? `: ${typeof detail === 'string' ? detail : JSON.stringify(detail)}` : ''));
      }
    } finally {
      setIsPosting(false);
    }
  };
  useEffect(() => {
    if (hireCategory?.value && (sourceHirePaidAmount === 0 || parseFloat(sourceHirePaidAmount) === 0)) {
      setSourceHirePaidAmount(0);
      if (hireCategory?.value === "Standard") {
        setSourceHirePaidAmount(formData.hire.standard_hire_rate);
      } else if (hireCategory?.value === "Prestige") {
        setSourceHirePaidAmount(formData.hire.prestige_hire_rate);
      } else if (hireCategory?.value === "PCO/Taxi") {
        setSourceHirePaidAmount(formData.hire.pco_taxi_rate);
      } else if (hireCategory?.value === "Motorbike") {
        setSourceHirePaidAmount(formData.hire.motorbike_rate);
      } else {
        setSourceHirePaidAmount(0);
      }
    }
  }, [hireCategory]);

  return (
    <Form>

      {/* <div className="position-absolute text-center" style={{ top: '0.5%', right: '1.7%' }}>
        {sourceHirePaidStatus == 1 ? (
          <h4 className="text-success">PAID</h4>
        ) : (
          <h4 className="text-danger">UNPAID</h4>
        )}
      </div> */}

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label for="hireApprovedSelect">Hire Approved</Label>
            <AsyncPaginate
              styles={{
                menu: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                  scrollBehavior: 'smooth',
                  WebkitOverflowScrolling: 'touch',
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                }),
              }}
              className="basic-single"
              classNamePrefix="select"
              isSearchable={true}
              name="currentStatusSelect"
              id="currentStatusSelect"
              loadOptions={loadHireApprovedOption}
              value={hireApproved}
              onChange={(selected) => setHireApproved(selected)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireCategorySelect">Hire Category</Label>
            <AsyncPaginate
              styles={{
                menu: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                  scrollBehavior: 'smooth',
                  WebkitOverflowScrolling: 'touch',
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                }),
              }}
              className="basic-single"
              classNamePrefix="select"
              isSearchable={true}
              name="hireCategorySelect"
              id="hireCategorySelect"
              isDisabled={userType !== 'Super Admin' && sourceHirePaidStatus}
              loadOptions={loadHireCategories}
              value={hireCategory}
              onChange={(selected) => setHireCategory(selected)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireBookingInDate">Hire Booking In Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={hireBookingDate} setStartDate={setHireBookingDate} id={"hireBookingDate"} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <div className="d-flex align-items-center">
              <Label for="hireLeadSource">Hire Lead Source</Label>

              {hireLeadSource ? (
                <>
                  <div id="leadSourceInfo" className="bg-light cursor-pointer rounded-circle mx-2 h-20 w-20 d-flex justify-content-center align-items-center" style={{ marginBottom: 2 }} onClick={togglePopover} ref={popoverRef}>
                    <FontAwesomeIcon icon={faInfo} />
                  </div>
                  <UncontrolledPopover placement="top" target="leadSourceInfo" trigger="click" isOpen={popoverOpen} toggle={togglePopover}>
                    <div ref={popoverContentRef}>
                      <PopoverBody>
                        <p>Introducer: {hireLeadSource.introducer} </p>
                        <p>
                          Contact # <ContactLink>{hireLeadSource.contact}</ContactLink>
                        </p>
                        <p>
                          Mobile # <ContactLink>{hireLeadSource.mobile}</ContactLink>
                        </p>
                        <p>
                          Email <EmailLink subject={`NASL-${formId} / Client Name : ${`${formData?.title} ${formData?.first_name} ${formData?.middle_name} ${formData?.last_name}`} / Accident Date :  ${toYYYYMMDD(formData?.ib_claim?.accident_date, true)} / Client Reg :${formData?.vehicle_registration_no}`}>{hireLeadSource.email}</EmailLink>
                        </p>
                        {hireLeadSource.instructions && (
                          <>
                            <hr className="my-2" />
                            <p className="mb-0 font-weight-bold">Instructions:</p>
                            <p className="mb-0" style={{ whiteSpace: 'pre-wrap', fontSize: '0.875rem' }}>
                              {hireLeadSource.instructions}
                            </p>
                          </>
                        )}
                      </PopoverBody>
                    </div>
                  </UncontrolledPopover>
                </>
              ) : null}
            </div>
            <AsyncPaginate
              styles={{
                menu: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                  scrollBehavior: 'smooth',
                  WebkitOverflowScrolling: 'touch',
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                }),
              }}
              className="basic-single"
              classNamePrefix="select"
              isSearchable={true}
              name="hireLeadSource"
              id="hireLeadSource"
              loadOptions={loadLeadSourceOptionsWithDetails}
              additional={{
                page: 1,
              }}
              value={hireLeadSource}
              isDisabled={userType !== 'Super Admin' && sourceHirePaidStatus}
              debounceTimeout={300}
              onChange={(selected) => setHireLeadSource(selected)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireCommenceDate">Hire Commence Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={hireCommenceDate} setStartDate={setHireCommenceDate} id={"hireCommenceDate"} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireReferenceNo">Hire Reference #</Label>
            <Input type="text" id="hireReferenceNo" value={hireRefNo} onChange={(e) => setHireRefNo(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <Row>
            <Col md={12}>
              <FormGroup>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 6 }}>
                  <div className="d-flex align-items-center" style={{ gap: 6, minHeight: 24 }}>
                    <Label for="hireSupplier" className="text-nowrap mb-0">Hire Supplier</Label>
                    {supplierUnsaved && (
                      <>
                        <span id="badgeSupplierUnsaved" role="img" aria-label="Supplier change not saved" style={{ color: '#f79009', lineHeight: 1, cursor: 'help' }}>
                          <FontAwesomeIcon icon={faExclamationTriangle} />
                        </span>
                        <UncontrolledTooltip placement="top" target="badgeSupplierUnsaved" innerClassName="review-reason-tip">
                          <div className="text-left">
                            <div style={{ fontWeight: 600 }}>Supplier change not saved</div>
                            <div style={{ fontSize: 12, opacity: 0.85 }}>Click Update to save this supplier. Review and posting use the saved supplier.</div>
                          </div>
                        </UncontrolledTooltip>
                      </>
                    )}
                    {reviewLocked && !alreadyPosted && (
                      <>
                        <span id="badgeSupplierLocked" aria-label="Supplier locked" style={{ color: '#667085', lineHeight: 1, cursor: 'help' }}>
                          <FontAwesomeIcon icon={faLock} />
                        </span>
                        <UncontrolledTooltip placement="top" target="badgeSupplierLocked" innerClassName="review-reason-tip">
                          <div className="text-left">
                            <div style={{ fontWeight: 600 }}>Supplier locked</div>
                            <div style={{ fontSize: 12, opacity: 0.85 }}>Waiting for review. You can change it again after the reviewer accepts or rejects.</div>
                          </div>
                        </UncontrolledTooltip>
                      </>
                    )}
                    {needsReview && !alreadyPosted && reviewInfo.review_status === 'rejected' && (
                      <span id="badgeReviewRejected" role="button" tabIndex={0} aria-label="Rejected - view reason" onClick={() => setReasonModalOpen(true)} onKeyDown={(e) => { if (e.key === 'Enter') setReasonModalOpen(true); }} style={{ color: '#d92d20', cursor: 'pointer', lineHeight: 1 }}>
                        <FontAwesomeIcon icon={faTimesCircle} />
                      </span>
                    )}
                    {needsReview && !alreadyPosted && reviewInfo.review_status === 'accepted' && (
                      <>
                        <span id="badgeReviewApproved" aria-label="Approved" style={{ color: '#12b76a', lineHeight: 1 }}>
                          <FontAwesomeIcon icon={faCheckCircle} />
                        </span>
                        <UncontrolledTooltip placement="top" target="badgeReviewApproved">
                          Approved{reviewInfo.reviewed_by ? ` by ${reviewInfo.reviewed_by}` : ''}{reviewInfo.reviewed_at ? `, ${moment(reviewInfo.reviewed_at).format('DD MMM YYYY HH:mm')}` : ''}
                        </UncontrolledTooltip>
                      </>
                    )}
                  </div>
                  {hireSupplier?.label === "4th dimension" && (
                    <Button className="bg-transparent border-0 text-dark ms-auto" onClick={sendXML}>
                      Send Email
                    </Button>
                  )}
                  {needsReview && !alreadyPosted && reviewInfo.review_status !== 'accepted' && (
                    reviewInfo.review_status === 'submit_for_review' ? (
                      <span className="d-inline-flex align-items-center ml-auto" style={{ ...reviewChip, color: '#b54708', background: '#fffaeb', border: '1px solid #fedf89' }}>
                        <FontAwesomeIcon icon={faClock} /> Pending Review
                      </span>
                    ) : (
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        className="d-inline-flex align-items-center ml-auto"
                        style={{ gap: 6, borderRadius: 999, padding: '1px 12px', fontWeight: 600, fontSize: 12, lineHeight: '18px', whiteSpace: 'nowrap' }}
                        title={!hireSupplier?.value ? 'Select a hire supplier first' : supplierUnsaved ? 'Click Update to save the supplier first' : reviewInfo.review_status === 'rejected' ? 'Fix the issues and send it for review again' : 'Send this case to a reviewer for approval'}
                        onClick={() => setSubmitReviewOpen(true)}
                        disabled={!hireSupplier?.value || supplierUnsaved}
                      >
                        <FontAwesomeIcon icon={faPaperPlane} /> {reviewInfo.review_status === 'rejected' ? 'Resubmit For Review' : 'Submit For Review'}
                      </Button>
                    )
                  )}
                  {needsReview && !alreadyPosted && reviewInfo.review_status === 'accepted' && (
                    <div className="d-flex align-items-center ml-auto" style={{ gap: 6 }}>
                      <Button id="btnPostReview" color="primary" size="sm" className="d-inline-flex align-items-center" style={{ gap: 6, borderRadius: 6, padding: '2px 12px', fontWeight: 600, fontSize: 12, lineHeight: '18px' }} onClick={() => (isKindertonSupplier ? setConfirmOpen(true) : setEnterpriseConfirmOpen(true))} disabled={isPosting || supplierUnsaved} title={supplierUnsaved ? 'Click Update to save the supplier first' : undefined}>
                        <FontAwesomeIcon icon={faPaperPlane} /> Post
                      </Button>
                      <Tooltip
                        placement="top"
                        isOpen={postTipOpen}
                        target="btnPostReview"
                        toggle={() => setPostTipOpen(!postTipOpen)}
                      >
                        Post case to {reviewSupplierLabel} API
                      </Tooltip>
                    </div>
                  )}
                  {(isKindertonSupplier || isEnterpriseSupplier) && alreadyPosted && (
                    <span className="badge bg-success ms-2">Transferred</span>
                  )}
                </div>
                <AsyncPaginate
                  styles={{
                    menu: (base) => ({
                      ...base,
                      maxHeight: 150,
                      overflowY: 'auto',
                      scrollBehavior: 'smooth',
                      WebkitOverflowScrolling: 'touch',
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: 150,
                      overflowY: 'auto',
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isSearchable={true}
                  name="hireSupplier"
                  id="hireSupplier"
                  loadOptions={(search, loadedOptions, { page }) =>
                    hireLeadSource?.hire_preference === 'Yes'
                      ? loadHireSuppliersForLeadSource(search, loadedOptions, { page, hireLeadSource })
                      : loadHireSuppliers(search, loadedOptions, { page })
                  }
                  additional={{
                    page: 1,
                    hireLeadSource
                  }}
                  isDisabled={(userType !== 'Super Admin' && sourceHirePaidStatus) || !hireLeadSource?.value || reviewLocked}
                  value={hireSupplier}
                  debounceTimeout={300}
                  onChange={(selected) => {
                    setHireSupplier(selected);
                    checkKindertonSupplier(selected?.value);
                  }}
                  key={hireLeadSource?.value}
                />
                {needsReview && !alreadyPosted && reviewInfo.review_status === 'rejected' && (
                  <>
                    <UncontrolledTooltip placement="bottom" target="badgeReviewRejected" innerClassName="review-reason-tip">
                      {String(reviewInfo.review_reject_reason || '').replace(/\s+/g, ' ').slice(0, 140)}
                      {String(reviewInfo.review_reject_reason || '').length > 140 ? '…' : ''}
                      <div className="small mt-1" style={{ opacity: 0.75 }}>Rejected · click to view full reason</div>
                    </UncontrolledTooltip>
                    <Modal isOpen={reasonModalOpen} toggle={() => setReasonModalOpen(false)} centered>
                      <ModalHeader toggle={() => setReasonModalOpen(false)}>Rejection Reason</ModalHeader>
                      <ModalBody>
                        <div style={{ maxHeight: '55vh', overflowY: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{reviewInfo.review_reject_reason}</div>
                        {reviewInfo.reviewed_by && (
                          <div className="text-muted small mt-3 pt-2 border-top">
                            Rejected by {reviewInfo.reviewed_by}{reviewInfo.reviewed_at ? ` on ${moment(reviewInfo.reviewed_at).format('DD MMM YYYY HH:mm')}` : ''}
                          </div>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        <Button color="secondary" onClick={() => setReasonModalOpen(false)}>Close</Button>
                      </ModalFooter>
                    </Modal>
                  </>
                )}
                <Modal isOpen={submitReviewOpen} toggle={() => { if (!isSubmittingReview) setSubmitReviewOpen(false); }} centered backdrop={isSubmittingReview ? 'static' : true} keyboard={!isSubmittingReview}>
                  <ModalHeader toggle={() => { if (!isSubmittingReview) setSubmitReviewOpen(false); }}>Submit For Review</ModalHeader>
                  <ModalBody>
                    Submit this case for review? A reviewer must accept it before it can be posted to {reviewSupplierLabel}.
                    <div className="text-muted small mt-2">Make sure your latest hire changes are saved first.</div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => setSubmitReviewOpen(false)} disabled={isSubmittingReview}>Cancel</Button>
                    <LoadingButton onClick={submitForReview} isLoading={isSubmittingReview}>Confirm & Submit</LoadingButton>
                  </ModalFooter>
                </Modal>
                <Modal isOpen={confirmOpen} toggle={() => { if (!isPosting) { setConfirmOpen(!confirmOpen); setPostErrors(null); } }} centered backdrop={isPosting ? 'static' : true} keyboard={!isPosting}>
                  <ModalHeader toggle={() => { if (!isPosting) setConfirmOpen(!confirmOpen); }}>Confirm Post</ModalHeader>
                  <ModalBody>
                    {isPosting ? (
                      <div className="d-flex align-items-center">
                        <Spinner size="sm" color="primary" className="mr-2" />
                        <span>Posting to Kinderton, please wait...</span>
                      </div>
                    ) : (
                      <>
                        Are you sure you want to post this case to Kinderton? This will send case details to the configured Kinderton API.
                        <div className="row mt-3 g-2">
                          {/* Claim Type Selection for Repair cases - left */}
                          {!formData?.service_type?.includes('Repair') && (
                            <div className="col-md-6">
                              <div className="p-3 border rounded bg-light h-100">
                                <div className="font-weight-bold mb-2">Select Claim Type:</div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="claimType"
                                    id="claimTypeCOI"
                                    value="COI"
                                    checked={claimTypeSelection === 'COI'}
                                    onChange={(e) => setClaimTypeSelection(e.target.value)}
                                  />
                                  <label className="form-check-label" htmlFor="claimTypeCOI">
                                    COI
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="claimType"
                                    id="claimTypeTPI"
                                    value="TPI"
                                    checked={claimTypeSelection === 'TPI'}
                                    onChange={(e) => setClaimTypeSelection(e.target.value)}
                                  />
                                  <label className="form-check-label" htmlFor="claimTypeTPI">
                                    TPI
                                  </label>
                                </div>
                                {!claimTypeSelection && (
                                  <div className="text-danger small mt-1">Please select a claim type</div>
                                )}
                              </div>
                            </div>
                          )}
                          {/* Workstream - right */}
                          <div className={!formData?.service_type?.includes('Repair') ? 'col-md-6' : 'col-12'}>
                            <div className="p-3 border rounded bg-light h-100">
                              <div className="font-weight-bold mb-2">Workstream:</div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="workstream"
                                  id="workstreamDefault"
                                  value="23677"
                                  checked={workstreamSelection === '23677'}
                                  onChange={(e) => setWorkstreamSelection(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="workstreamDefault">
                                  Default
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="workstream"
                                  id="workstreamLairds"
                                  value="25793"
                                  checked={workstreamSelection === '25793'}
                                  onChange={(e) => setWorkstreamSelection(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="workstreamLairds">
                                  Laird&apos;s
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {postErrors ? (
                          <div className="mt-3 p-2 border rounded" style={{ maxHeight: 180, overflowY: 'auto' }}>
                            <div className="text-danger font-weight-bold mb-2">{postErrors.title || 'Validation errors'}</div>
                            {Object.keys(postErrors.errors || {}).length ? (
                              <ul className="mb-0 pl-3">
                                {Object.entries(postErrors.errors).map(([field, msgs]) => (
                                  <li key={field}>
                                    <span className="font-weight-bold">{field}:</span> {Array.isArray(msgs) ? msgs.join(', ') : msgs}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div className="text-muted">No details provided.</div>
                            )}
                            {(postErrors.traceId || postErrors.correlationId) && (
                              <div className="mt-2 text-muted small">
                                {postErrors.traceId && <div>Trace ID: {postErrors.traceId}</div>}
                                {postErrors.correlationId && <div>Correlation ID: {postErrors.correlationId}</div>}
                              </div>
                            )}
                          </div>
                        ) : null}
                      </>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => setConfirmOpen(false)} disabled={isPosting}>Cancel</Button>
                    <LoadingButton
                      onClick={postToKinderton}
                      isLoading={isPosting}
                      disabled={(!formData?.service_type.includes("Repair") && !claimTypeSelection)}
                    >
                      Confirm & Post
                    </LoadingButton>
                  </ModalFooter>
                </Modal>

                {/* Enterprise Confirm Modal */}
                <Modal isOpen={enterpriseConfirmOpen} toggle={() => { if (!isPosting) { setEnterpriseConfirmOpen(!enterpriseConfirmOpen); setSelectedReferrerCode(''); setPostErrors(null); } }} centered backdrop={isPosting ? 'static' : true} keyboard={!isPosting}>
                  <ModalHeader toggle={() => { if (!isPosting) setEnterpriseConfirmOpen(!enterpriseConfirmOpen); }}>Select Referrer Code</ModalHeader>
                  <ModalBody>
                    <div className="mb-3">
                      <Label>Please select a referrer code:</Label>
                      <div className="mt-3">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="radio"
                              name="referrerCode"
                              value="AM00012"
                              checked={selectedReferrerCode === 'AM00012'}
                              onChange={(e) => setSelectedReferrerCode(e.target.value)}
                            />
                            {' '}AM00012
                          </Label>
                        </FormGroup>
                        <FormGroup check className="mt-2">
                          <Label check>
                            <Input
                              type="radio"
                              name="referrerCode"
                              value="Am137"
                              checked={selectedReferrerCode === 'Am137'}
                              onChange={(e) => setSelectedReferrerCode(e.target.value)}
                            />
                            {' '}Am137
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                    {postErrors && (
                      <div className="mt-3">
                        {postErrors.categorized ? (
                          <div className="" style={{ 
                            borderRadius: '12px', 
                            border: '1px solid #f8d7da', 
                            backgroundColor: '#fff5f5',
                            padding: '18px',
                            boxShadow: '0 2px 8px rgba(220, 53, 69, 0.1)'
                          }}>
                            <div className="d-flex align-items-center mb-1">
                              <div className="d-flex align-items-center justify-content-center" 
                                   style={{ 
                                     width: '22px', 
                                     height: '22px', 
                                     borderRadius: '50%', 
                                     backgroundColor: '#dc3545',
                                     marginRight: '7px'
                                   }}>
                                <FontAwesomeIcon 
                                  icon={faInfo} 
                                  style={{ fontSize: '15px', color: 'white' }}
                                />
                              </div>
                              <div className="font-weight-bold" style={{ fontSize: '18px', color: '#dc3545', lineHeight: '1.2' }}>
                                {postErrors.title || 'Error'}
                              </div>
                            </div>
                            
                            <div className="mb-2" style={{ color: '#495057', fontSize: '14px', lineHeight: '1.5' }}>
                              Please complete the following required fields to proceed with the Enterprise submission:
                            </div>

                            {postErrors.errors && (() => {
                              // Count active error categories
                              const activeCategories = [
                                postErrors.errors.clientDetails?.length > 0,
                                postErrors.errors.clientVehicle?.length > 0,
                                postErrors.errors.accidentDetails?.length > 0,
                                postErrors.errors.defendantDetails?.length > 0
                              ].filter(Boolean).length;
                              
                              // Determine column class based on number of categories
                              let colClass = 'col-12'; // Default to full width
                              if (activeCategories === 1) {
                                colClass = 'col-12 col-md-8 col-lg-6'; // Center with max width
                              } else if (activeCategories === 2) {
                                colClass = 'col-12 col-md-6'; // 2 columns
                              } else if (activeCategories === 3) {
                                colClass = 'col-12 col-sm-6 col-lg-4'; // 3 columns on large screens
                              } else if (activeCategories === 4) {
                                colClass = 'col-12 col-sm-6 col-lg-3'; // 4 columns on large screens
                              }
                              
                              return (
                                <div className="row w-100 d-flex flex-wrap gap-0" style={{ minHeight: '200px' }}>
                                  {postErrors.errors.clientDetails && postErrors.errors.clientDetails.length > 0 && (
                                    <div className={`${colClass} p-1 d-flex`} style={{ marginBottom: '0px' }}>
                                      <div className="card mb-0 w-100" style={{ 
                                        border: '1px solid #f8d7da',
                                        borderLeft: '4px solid #dc3545', 
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.2s ease-in-out'
                                      }}>
                                        <div className="card-body" style={{ padding: '8px' }}>
                                          <h6 className="card-title mb-2" style={{ 
                                            fontSize: '14px', 
                                            fontWeight: '600', 
                                            color: '#dc3545',
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}>
                                            <FontAwesomeIcon icon="user" className="mr-2" style={{ fontSize: '14px' }} />
                                            Client Details
                                          </h6>
                                          <ul className="mb-0 pl-3" style={{ fontSize: '13px', lineHeight: '1.2' }}>
                                            {postErrors.errors.clientDetails.map((field, index) => (
                                              <li key={index} style={{ color: '#6c757d', marginBottom: '4px' }}>{field}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {postErrors.errors.clientVehicle && postErrors.errors.clientVehicle.length > 0 && (
                                    <div className={`${colClass} p-1 d-flex`} style={{ marginBottom: '0px' }}>
                                      <div className="card mb-0 w-100" style={{ 
                                        border: '1px solid #fff3cd',
                                        borderLeft: '4px solid #ffc107', 
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.2s ease-in-out'
                                      }}>
                                        <div className="card-body" style={{ padding: '8px' }}>
                                          <h6 className="card-title mb-2" style={{ 
                                            fontSize: '14px', 
                                            fontWeight: '600', 
                                            color: '#856404',
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}>
                                            <FontAwesomeIcon icon="car" className="mr-2" style={{ fontSize: '14px' }} />
                                            Client Vehicle
                                          </h6>
                                          <ul className="mb-0 pl-3" style={{ fontSize: '13px', lineHeight: '1.2' }}>
                                            {postErrors.errors.clientVehicle.map((field, index) => (
                                              <li key={index} style={{ color: '#6c757d', marginBottom: '4px' }}>{field}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {postErrors.errors.accidentDetails && postErrors.errors.accidentDetails.length > 0 && (
                                    <div className={`${colClass} p-1 d-flex`} style={{ marginBottom: '0px' }}>
                                      <div className="card mb-0 w-100" style={{ 
                                        border: '1px solid #bee5eb',
                                        borderLeft: '4px solid #17a2b8', 
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.2s ease-in-out'
                                      }}>
                                        <div className="card-body" style={{ padding: '8px' }}>
                                          <h6 className="card-title mb-2" style={{ 
                                            fontSize: '14px', 
                                            fontWeight: '600', 
                                            color: '#0c5460',
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}>
                                            <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" style={{ fontSize: '14px' }} />
                                            Accident Details
                                          </h6>
                                          <ul className="mb-0 pl-3" style={{ fontSize: '13px', lineHeight: '1.2' }}>
                                            {postErrors.errors.accidentDetails.map((field, index) => (
                                              <li key={index} style={{ color: '#6c757d', marginBottom: '4px' }}>{field}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {postErrors.errors.defendantDetails && postErrors.errors.defendantDetails.length > 0 && (
                                    <div className={`${colClass} p-1 d-flex`} style={{ marginBottom: '0px' }}>
                                      <div className="card mb-0 w-100" style={{ 
                                        border: '1px solid #e2e3e5',
                                        borderLeft: '4px solid #6c757d', 
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.2s ease-in-out'
                                      }}>
                                        <div className="card-body" style={{ padding: '8px' }}>
                                          <h6 className="card-title mb-2" style={{ 
                                            fontSize: '14px', 
                                            fontWeight: '600', 
                                            color: '#383d41',
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}>
                                            <FontAwesomeIcon icon="user-shield" className="mr-2" style={{ fontSize: '14px' }} />
                                            Defendant Details
                                          </h6>
                                          <ul className="mb-0 pl-3" style={{ fontSize: '13px', lineHeight: '1.2' }}>
                                            {postErrors.errors.defendantDetails.map((field, index) => (
                                              <li key={index} style={{ color: '#6c757d', marginBottom: '4px' }}>{field}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        ) : (
                          <div className="alert alert-danger">
                            <div className="font-weight-bold mb-2">{postErrors.title || 'Error'}</div>
                            {postErrors.errors && Object.keys(postErrors.errors).length > 0 && (
                              <div className="mb-2">
                                {Object.entries(postErrors.errors).map(([field, msgs]) => (
                                  <div key={field} className="mb-1">
                                    <strong>{field}:</strong> {Array.isArray(msgs) ? msgs.join(', ') : msgs}
                                  </div>
                                ))}
                              </div>
                            )}
                            {(postErrors.traceId || postErrors.correlationId) && (
                              <div className="mt-2 text-muted small">
                                {postErrors.traceId && <div>Trace ID: {postErrors.traceId}</div>}
                                {postErrors.correlationId && <div>Correlation ID: {postErrors.correlationId}</div>}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => { setEnterpriseConfirmOpen(false); setSelectedReferrerCode(''); }} disabled={isPosting}>Cancel</Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        if (!selectedReferrerCode) {
                          toastr.warning('Warning', 'Please select a referrer code');
                          return;
                        }
                        postToEnterprise(selectedReferrerCode);
                      }}
                      disabled={isPosting || !selectedReferrerCode}
                    >
                      {isPosting && <Spinner size="sm" color="light" className="mr-2" />}
                      Confirm Post
                    </Button>
                  </ModalFooter>
                </Modal>
              </FormGroup>
            </Col>
            {/* {hireSupplier?.label === "4th dimension" && (
              // <Col md={3} style={{ marginTop: '26px' }} className="p-0">
              //   <Button color="primary" onClick={sendXML}>
              //     Send
              //   </Button>
              // </Col>
            )} */}
          </Row>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireCompleteDate">Hire Complete Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={hireCompleteDate} setStartDate={setHireCompleteDate} id={"hireCompleteDate"} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="outlay">Outlay</Label>
            <Select className="basic-single" classNamePrefix="select" name="outlay" value={outlay} options={yesOrNoOptions} onChange={(selectedOption) => setOutlay(selectedOption)} />
          </FormGroup>
        </Col>

        {userType === "Super Admin" || userType === "Account" ? (
          <>
            <Col md={4}>
              <FormGroup>
                <Label for="sourceHirePaidDate">Source Hire Paid Date</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={sourceHirePaidDate} setStartDate={setSourceHirePaidDate} id={"sourceHirePaidDate"} />
                </Col>
                <div className="ml-4">
                  <Input type="checkbox" id="sourceHirePaidStatus" checked={sourceHirePaidStatus} onChange={(e) => setSourceHirePaidStatus(e.target.checked)} />
                  <Label for="sourceHirePaidStatus">Source Hire Paid Status</Label>
                </div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="sourceHirePaidAmount">Source Hire Paid Amount</Label>
                <Input type="number" onWheel={(e) => e.target.blur()} id="sourceHirePaidAmount" value={sourceHirePaidAmount} onChange={(e) => setSourceHirePaidAmount(e.target.value)} />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="naslHirePaidDateFE">NASL Hire Paid Date (FE)</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={naslHirePaidDateFE} setStartDate={setNaslHirePaidDateFE} id={"naslHirePaidDateFE"} />
                </Col>
                <div className="ml-4">
                  <Input type="checkbox" id="naslHirePaidStatusFE" checked={naslHirePaidStatusFE} onChange={(e) => setNaslHirePaidStatusFE(e.target.checked)} />
                  <Label for="naslHirePaidStatusFE">NASL Hire Paid Status (FE)</Label>
                </div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="naslHirePaidAmountFE">NASL Hire Paid Amount (FE)</Label>
                <Input type="number" onWheel={(e) => e.target.blur()} id="naslHirePaidAmountFE" value={naslHirePaidAmountFe} onChange={(e) => setNaslHirePaidAmountFe(e.target.value)} />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="naslHirePaidDateBE">NASL Hire Paid Date (BE)</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={naslHirePaidDateBE} setStartDate={setNaslHirePaidDateBE} id={"naslHirePaidDateBE"} />
                </Col>
                <div className="ml-4">
                  <Input type="checkbox" id="naslHirePaidStatusBE" checked={naslHirePaidStatusBE} onChange={(e) => setNaslHirePaidStatusBE(e.target.checked)} />
                  <Label for="naslHirePaidStatusBE">NASL Hire Paid Status (BE)</Label>
                </div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="naslHirePaidAmountBE">NASL Hire Paid Amount (BE)</Label>
                <Input type="number" onWheel={(e) => e.target.blur()} id="naslHirePaidAmountBE" value={naslHirePaidAmountBe} onChange={(e) => setNaslHirePaidAmountBe(e.target.value)} />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="hireAccessoriesPaymentDate">Hire Accessories Payment Date</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={hireAccessoriesPaymentDate} setStartDate={setHireAccessoriesPaymentDate} id={"hireAccessoriesPaymentDate"} />
                </Col>
                <div className="ml-4">
                  <Input type="checkbox" id="accessoryPamentStatus" checked={accessoryPamentStatus} onChange={(e) => setAccessoryPamentStatus(e.target.checked)} />
                  <Label for="accessoryPamentStatus">Accessory Payment Status</Label>
                </div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="hireAccessoriesPaymentAmount">Accessories Payment Amount</Label>
                <Input type="number" onWheel={(e) => e.target.blur()} id="hireAccessoriesPaymentAmount" value={accessoriesPaymentAmount} onChange={(e) => setAccessoriesPaymentAmount(e.target.value)} />
              </FormGroup>
            </Col>
          </>
        ) : (
          <>
            <Col md={4}>
              <FormGroup>
                <Label for="sourceHirePaidDate">Source Hire Paid Date</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={sourceHirePaidDate} id={"sourceHirePaidDate"} disabled />
                </Col>
              </FormGroup>
            </Col>
          </>
        )}

        <Col md={4}>
          <FormGroup>
            <Label for="paServicingDate">PA Servicing Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={paServicingDate} setStartDate={setPaServicingDate} id={"paServicingDate"} />
            </Col>
            <div className="ml-4">
              <Input type="checkbox" id="servicingPaymentStatus" checked={servicingPaymentStatus} onChange={(e) => setservicingPaymentStatus(e.target.checked)} />
              <Label for="servicingPaymentStatus">Servicing Payment Status</Label>
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="paServicingAmount">PA Servicing Amount</Label>
            <Input type="number" onWheel={(e) => e.target.blur()} id="paServicingAmount" value={paServicingAmount} onChange={(e) => setPaServicingAmount(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireChaseDate">Hire Chase Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={hireChaseDate} setStartDate={setHireChaseDate} id={"hireChaseDate"} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="hireTransferDate">Hire Transfer Date</Label>
            <Col md={12} className="p-0">
              <CustomDate startDate={hireTransferDate} setStartDate={setHireTranserDate} id={"hireTransferDate"} />
            </Col>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <RequiredLabel for="hireStatus">Hire Status {validationErrors.hireStatus ? <span className="text-danger">(Required)</span> : ''}</RequiredLabel>
            <AsyncPaginate
              styles={{
                menu: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                  scrollBehavior: 'smooth',
                  WebkitOverflowScrolling: 'touch',
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: 150,
                  overflowY: 'auto',
                }),
              }}
              className={`basic-single ${validationErrors.hireStatus ? 'is-invalid border-danger border' : ''}`}
              classNamePrefix="select"
              isSearchable={true}
              name="hireStatus"
              id="hireStatus"
              loadOptions={loadHireStatus}
              value={hireStatus}
              required
              onChange={(selected) => setHireStatus(selected)}
              clearable
            />
          </FormGroup>
        </Col>
        {hireStatus?.value === "Reject" && (
          <>
            <Col md={4}>
              <FormGroup>
                <Label for="reasonOfRejection">Reason of Rejection</Label>
                <AsyncPaginate
                  styles={{
                    menu: (base) => ({
                      ...base,
                      maxHeight: 150,
                      overflowY: 'auto',
                      scrollBehavior: 'smooth',
                      WebkitOverflowScrolling: 'touch',
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: 150,
                      overflowY: 'auto',
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isSearchable={true}
                  name="reasonOfRejection"
                  id="reasonOfRejection"
                  loadOptions={loadRejectReason}
                  value={rejectReason}
                  onChange={(selected) => setRejectReason(selected)}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="rejection_date">Rejection Date</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={rejection_date} setStartDate={setRejectionDate} id={"rejection_date"} disabled />
                </Col>
              </FormGroup>
            </Col>
          </>
        )}
        {userType === "Super Admin" || userType === "Account" ? (
          <>
            <Col md={4}>
              <FormGroup>
                <Label for="naslAccessoriesPaymentDate">NASL Accessories Payment Date</Label>
                <Col md={12} className="p-0">
                  <CustomDate startDate={naslAccessoriesPaymentDate} setStartDate={setNaslAccessoriesPaymentDate} id={"naslAccessoriesPaymentDate"} />
                </Col>
                <div className="ml-4">
                  <Input type="checkbox" id="naslAccessoryPaymentStatus" checked={naslAccessoryPamentStatus} onChange={(e) => setNaslAccessoryPamentStatus(e.target.checked)} />
                  <Label for="naslAccessoryPaymentStatus">NASL Accessory Payment Status</Label>
                </div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="naslAccessoriesPaymentAmount">NASL Accessories Payment Amount</Label>
                <Input type="number" onWheel={(e) => e.target.blur()} id="naslAccessoriesPaymentAmount" value={naslAccessoriesPaymentAmount} onChange={(e) => setNaslAccessoriesPaymentAmount(e.target.value)} />
              </FormGroup>
            </Col>
          </>
        ) : null}

        <Col md={4}>
          <FormGroup>
            <Label>Priority</Label>
            <Row className="pl-4">
              <Col>
                <Label check>
                  <Input type="radio" name="priority" checked={priority === "High"} onChange={() => setPriority("High")} />
                  High
                </Label>
              </Col>
              <Col>
                <Label check>
                  <Input type="radio" name="priority" checked={priority === "Medium"} onChange={() => setPriority("Medium")} />
                  Medium
                </Label>
              </Col>
              <Col>
                <Label check>
                  <Input type="radio" name="priority" checked={priority === "Low"} onChange={() => setPriority("Low")} />
                  Low
                </Label>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>

      <Notes
        noteDescription={noteDescription}
        setNoteDescription={setNoteDescription}
        sendSMSTo={sendSMSTo}
        setSendSMSTo={setSendSMSTo}
        addAsReminderDate={addAsReminderDate}
        setAddAsReminderDate={setAddAsReminderDate}
        reminderUsers={reminderUsers}
        setReminderUsers={setReminderUsers}
        sendEmailTo={sendEmailTo}
        setSendEmailTo={setSendEmailTo}
        addNoteTo={addNoteTo}
        setAddNoteTo={setAddNoteTo}
        isAddNoteOnCallActive={isAddNoteOnCallActive}
        setIsAddNoteOnCallActive={setIsAddNoteOnCallActive}
        sendSMSMobile={sendSMSMobile}
        setSendSMSMobile={setSendSMSMobile}
        isAddNotActive={isAddNotActive}
        setIsAddNotActive={setIsAddNotActive}
        isPinNoteActive={isPinNoteActive}
        setIsPinNoteActive={setIsPinNoteActive}
        isAddAsReminderActive={isAddAsReminderActive}
        setIsAddAsReminderActive={setIsAddAsReminderActive}
        isSendEmailActive={isSendEmailActive}
        setIsSendEmailActive={setIsSendEmailActive}
        isSendSMSActive={isSendSMSActive}
        setIsSendSMSActive={setIsSendSMSActive}
        isTaskActive={isTaskActive}
        setIsTaskActive={setIsTaskActive}
        taskUsers={taskUsers}
        setTaskUsers={setTaskUsers}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />

      <div className="d-flex justify-content-end">
        <ParamsLink to="/administration/cases" className="mr-2">
          <Button color="primary">Exit</Button>
        </ParamsLink>
        <LoadingButton onClick={updateHandler} isLoading={isUpdating}>
          Update
        </LoadingButton><LoadingButton onClick={() => {
          setIsLoading(true);
          instance.post(`/case/addNoteOnCall/${formId}`, {
            note: {
              is_add_note_on_call: 1,
              type: "Hire"
            }
          });
          toastr.success("Success", "Added successfully");
          setIsLoading(false);
          getNotes();
          setTimeout(() => {
            getNotes();
          }, 500);

        }} className="ml-2" isLoading={isLoading}>
          On Call
        </LoadingButton>
      </div>
    </Form>
  );
};

export default Hire;
